
import httpClient from './httpClient';
const prefix = 'company'

export default {
  async getManageUsers(page = 1, perPage = 20) {
    const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getManageUsers?page=${page}&perPage=${perPage}`)

    return data
  },
  async getAllManageUsers(page = 1, perPage = 20) {
    const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getAllManageUsers?page=${page}&perPage=${perPage}`)

    return data
  },
  async getCompaniesData(company_id){
    const {data} = await httpClient({requiresAuth:true}).get(`${prefix}/getCompaniesData?company_id=${company_id}`)
    return data
  },
  async getBusinessId(company_id){
    const {data} = await httpClient({requiresAuth:true}).get(`${prefix}/getBusinessId?company_id=${company_id}`)
    return data
  },
  async getCompanyById(id){
    const {data} = await httpClient({requiresAuth:true}).get(`${prefix}/getCompanyById/${id}`)
    return data.data
  },
  async updateCompanyData(companyId, payload) {
      const { data } = await httpClient({ requiresAuth: true }).put(`${prefix}/updateCompanyData/${companyId}`, payload)
      return data  
  }
}